var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgSchedules = function SvgSchedules(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "#7C86A3",
    viewBox: "0 0 13 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.466 8.5c0 .22-.178.398-.398.398h-.75A.4.4 0 0 1 8.92 8.5V7.01a.398.398 0 0 1 .796 0v1.092h.352c.22 0 .398.178.398.398"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.198 0c.22 0 .398.178.398.398v.09h6.408v-.09a.398.398 0 1 1 .796 0v.09h.8a1 1 0 0 1 1 1v4.36a3.5 3.5 0 1 1-5.167 4.638H1a1 1 0 0 1-1-1V1.49a1 1 0 0 1 1-1h.8V.398c0-.22.178-.398.398-.398M1.8 1.289H1a.2.2 0 0 0-.2.2v1.027h10V1.49a.2.2 0 0 0-.2-.2h-.8v.335a.398.398 0 0 1-.796 0V1.29H2.596v.335a.398.398 0 0 1-.796 0zm9 2.024H.8v6.174c0 .11.09.2.2.2h5.021A3.5 3.5 0 0 1 10.8 5.33zM9.315 11.2a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4",
    clipRule: "evenodd"
  })));
};
var Memo = /*#__PURE__*/memo(SvgSchedules);
export default Memo;